<div *ngIf="match() as match" class="match-tile">
  <div class="match-tile__datebox">
    <div class="match-tile__datebox-content">
      <div class="match-tile__datebox-content__date">
        {{ match.start_time | date: 'dd MMM HH:mm' }}
      </div>
      <div class="match-tile__datebox-content__venue">{{ match.venue.name }}</div>
    </div>
    <div></div>
  </div>
  <div class="match-tile__teambox">
    <div class="match-tile__teambox__club">
      @if (homeSquadLogoError()) {
      <app-icon
        name="club-logo-placeholder"
        class="match-tile__club-logo--placeholder"
      ></app-icon>
      } @else {
      <img
        [src]="match.home_squad.club_image | imageVariant: {width: 48, height: 48}"
        alt="Home club logo"
        class="match-tile__club-logo"
        (error)="homeSquadLogoError.set(true)"
      />
      }

      <div class="match-tile__teambox__club__name">{{ match.home_squad.club_name }}</div>
    </div>
    <div class="match-tile__teambox__separator">
      @if(match.status === 'pending') {
      <div class="match-tile__teambox__separator__icon-wrapper">
        <app-icon name="versus"></app-icon>
      </div>
      } @else {
      <div class="match-tile__teambox__separator__score">
        <div>{{ match?.home_squad_score }}</div>
        <div>:</div>
        <div>{{ match?.away_squad_score }}</div>
      </div>
      }
    </div>
    <div class="match-tile__teambox__club">
      @if (awaySquadLogoError()) {
      <app-icon
        name="club-logo-placeholder"
        class="match-tile__club-logo--placeholder"
      ></app-icon>
      } @else {
      <img
        [src]="match.away_squad.club_image | imageVariant: {width: 48, height: 48}"
        alt="Away club logo"
        class="match-tile__club-logo"
        (error)="awaySquadLogoError.set(true)"
      />
      }
      <div class="match-tile__teambox__club__name">{{ match.away_squad.club_name }}</div>
    </div>
  </div>
  @if (showAnyButton()) {
  <div class="match-tile__buttons">
    @if (showMatchCenterLink() && matchCenterUrl()) {
    <a
      [routerLink]="matchCenterUrl()"
      class="match-tile__button match-tile__button--secondary"
      [class.match-tile__button--full]="!showTicketsLink() && !showHighlightsLink()"
    >
      <span>{{ 'matchTile.matchCenter' | translate }}</span>
    </a>
    } @if (showHighlightsLink() && highlightsUrl()) {
    <a
      [href]="highlightsUrl()"
      target="_blank"
      rel="noopener noreferrer"
      class="match-tile__button match-tile__button--primary"
      [class.match-tile__button--full]="!showMatchCenterLink()"
    >
      <span>{{ 'matchTile.highlights' | translate }}</span>
    </a>
    } @else if (showTicketsLink() && ticketsUrl()) {
    <a
      [href]="ticketsUrl()"
      target="_blank"
      rel="noopener noreferrer"
      class="match-tile__button match-tile__button--primary"
      [class.match-tile__button--full]="!showMatchCenterLink()"
    >
      <span>{{ 'matchTile.tickets' | translate }}</span>
    </a>
    }
  </div>
  }
</div>
